import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { RouteConstants } from 'src/app/constants/route-constants';
import { ActivationComponent } from './components/activation/activation.component';
import { environment } from 'src/environments/environment';
import { authenticationGuard } from './guard/self-serve-auth.guard';
import { BrandSelectionPageComponent } from './components/brand-selection-page/brand-selection-page.component';
import {brandSelectionGuard} from "./guard/brand-selection.guard";

const emptyRoutes: Routes = [
  {
    path: RouteConstants.empty,
    component: BrandSelectionPageComponent,
    pathMatch: 'full',
    canActivate: [brandSelectionGuard]
  },
  {
    path: RouteConstants.activate.self,
    component: ActivationComponent,
    pathMatch: 'full',
    canActivate: [authenticationGuard]
  }
];
const routes: Routes = [];

if (environment.name === 'local' || environment.name === 'dev') {
  routes.push({
    path: 'developer',
    loadChildren: () =>
      import('./developer/developer.module').then((m) => m.DeveloperModule),
  });
}

@NgModule({
  imports: [
    RouterModule.forRoot([...emptyRoutes, ...routes], <ExtraOptions>{
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
